import { deriveLinksVars } from "./contrastCheck";

/**
 * The CSS variables of the "links" (Linktree-style) theme — v149.72.
 *
 * The owner picks three colours and an optional background image
 * (`theme_settings.links`); muted and on-pill text colours are derived so
 * nothing renders invisible. Returns `undefined` for every other theme.
 *
 * Used by the designer's preview (`BioPreviewPanel`) and the public Action
 * Page (`PublicActionPage`). The public Web Link (`PublicCreatorDirectory`)
 * sets the same variables itself, as it always has — keep the two in step.
 * Spread the result on the `ah-theme ah-links ah-root` element.
 */
export function linksThemeStyle(theme, themeSettings) {
  if (theme !== "links") return undefined;
  const links = (themeSettings && themeSettings.links) || {};
  const bg = links.bg || "#4a5568";
  const pill = links.pill || "#ffffff";
  const fg = links.fg || "#1a1a1a";
  const derived = deriveLinksVars({ bg, pill, fg });
  return {
    "--ah-links-bg": bg,
    "--ah-links-pill": pill,
    "--ah-links-fg": fg,
    "--ah-links-block-fg": derived.blockFg,
    "--ah-links-muted": derived.muted,
    "--ah-links-block-muted": derived.blockMuted,
    "--ah-links-bg-image": links.bg_image ? `url("${links.bg_image}")` : "none",
  };
}
